<mat-form-field
  appearance="outline"
  class="mat-input-custom"
  [ngClass]="readonly ? 'disbalestate' : ''"
>
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    [formControlName]="formControlNameData"
    ngDefaultControl
    id-automation="full_name"
    appAlphabetOnly
    appNoSpace
    [readonly]="readonly"
    maxlength="150"
  />
  <mat-error *ngIf="form.get(formControlNameData)?.hasError('required')">
    {{ label }} is required.
  </mat-error>
</mat-form-field>
